var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import Vue from 'vue';
import UiCheckbox from 'ui/v1/controls/UiCheckbox.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import { Preferences } from 'packages/notifications/entities/Preferences';
import { DefaultPreferences } from 'packages/notifications/entities/DefaultPreferences';
import { PreferencesRepository } from 'packages/notifications/PreferencesRepository';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import { omitBy, isEmpty } from 'lodash';
import { container } from 'tsyringe';
var SettingsView = /** @class */ (function (_super) {
    __extends(SettingsView, _super);
    function SettingsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationPreferences = new Preferences();
        _this.preferenceRepo = new PreferencesRepository();
        _this.authenticator = container.resolve(Authenticator);
        _this.prevDigestState = false;
        return _this;
    }
    SettingsView.prototype.mounted = function () {
        this.getCurrentPreferences();
        this.$root.$on('confirmationDialog.reverted', this.getCurrentPreferences);
        this.$root.$on('confirmationDialog.saving', this.savePreferences);
    };
    SettingsView.prototype.onDigestChange = function () {
        if (this.notificationPreferences.dailyDigest === this.prevDigestState) {
            return;
        }
        this.updateInAppPreference();
        this.prevDigestState = this.notificationPreferences.dailyDigest;
    };
    SettingsView.prototype.openConfirmation = function () {
        this.$root.$emit('openConfirmation');
    };
    Object.defineProperty(SettingsView.prototype, "columns", {
        get: function () {
            return [
                {
                    title: this.$t('notifications.settings.sends_email'),
                    pref: this.notificationPreferences.inboundEmail,
                },
                {
                    title: this.$t('notifications.settings.comments'),
                    pref: this.notificationPreferences.talentComment,
                },
                {
                    title: this.$t('notifications.settings.talent_joins'),
                    pref: this.notificationPreferences.newTalent,
                },
                {
                    title: this.$t('notifications.settings.talent_moves'),
                    pref: this.notificationPreferences.talentMoved,
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    SettingsView.prototype.getCurrentPreferences = function () {
        var _this = this;
        this.preferenceRepo.fetchForUser(this.authenticator.currentUserId).then(function (response) {
            var currentPrefs = new Preferences();
            _this.notificationPreferences = currentPrefs.fromArray(response.preferences);
            _this.prevDigestState = _this.notificationPreferences.dailyDigest;
        });
    };
    SettingsView.prototype.savePreferences = function () {
        var _this = this;
        var defaultPrefs = new DefaultPreferences();
        defaultPrefs.preferences = this.notificationPreferences.toArray();
        defaultPrefs.userId = this.authenticator.currentUserId;
        // API doesn't accept empty arrays
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        defaultPrefs.preferences.delivery = (omitBy(this.notificationPreferences.toArray().delivery, isEmpty));
        this.preferenceRepo.setPreferences(defaultPrefs).then(function () { return _this.$root.$emit('saved'); });
    };
    SettingsView.prototype.updateEmailPreference = function () {
        this.notificationConfiguration.forEach(function (pref) {
            if (!pref.app) {
                pref.email = false;
            }
        });
        this.openConfirmation();
    };
    SettingsView.prototype.updateInAppPreference = function () {
        this.notificationConfiguration.forEach(function (pref) {
            if (pref.email) {
                pref.app = true;
            }
        });
        this.openConfirmation();
    };
    SettingsView.prototype.toggleAllEmailNotifications = function () {
        var newValue = !this.hasAllEmailNotifications;
        this.notificationConfiguration.forEach(function (preference) { return preference.email = newValue; });
        this.updateInAppPreference();
    };
    Object.defineProperty(SettingsView.prototype, "hasAllEmailNotifications", {
        get: function () {
            return this.notificationConfiguration
                .filter(function (entry) { return entry.email; })
                .length === this.notificationConfiguration.length;
        },
        enumerable: false,
        configurable: true
    });
    SettingsView.prototype.toggleAllInAppNotifications = function () {
        var newValue = !this.hasInAppNotifications;
        this.notificationConfiguration.forEach(function (preference) { return preference.app = newValue; });
        this.updateEmailPreference();
    };
    Object.defineProperty(SettingsView.prototype, "hasInAppNotifications", {
        get: function () {
            return this.notificationConfiguration
                .filter(function (entry) { return entry.app; })
                .length === this.notificationConfiguration.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SettingsView.prototype, "notificationConfiguration", {
        get: function () {
            return [
                this.notificationPreferences.inboundEmail,
                this.notificationPreferences.newTalent,
                this.notificationPreferences.talentComment,
                this.notificationPreferences.talentMoved,
            ];
        },
        enumerable: false,
        configurable: true
    });
    SettingsView = __decorate([
        Component({
            components: {
                Icon: Icon,
                UiCheckbox: UiCheckbox,
            },
        })
    ], SettingsView);
    return SettingsView;
}(Vue));
export default SettingsView;
